import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=5ea1679d&scoped=true"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=5ea1679d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1679d",
  null
  
)

export default component.exports